module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600italic.woff?56e5756b696615d6164a625e1bcb1a9e";